import { render, staticRenderFns } from "./legacy-home-change-scene.vue?vue&type=template&id=b1166c10&scoped=true&"
import script from "./legacy-home-change-scene.vue?vue&type=script&lang=js&"
export * from "./legacy-home-change-scene.vue?vue&type=script&lang=js&"
import style0 from "./legacy-home-change-scene.vue?vue&type=style&index=0&id=b1166c10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1166c10",
  null
  
)

export default component.exports